import { ref, computed } from 'vue'

let nextId = 1
function genId() { return 'ctrl_' + (nextId++) }

// Common base properties for all OA form controls
const commonProps = {
  // 标识
  fieldId: '',       // 字段ID
  fieldName: '',     // 字段名称
  className: '',     // CSS类名

  // 数据绑定
  dataSource: '',       // 数据源（兼容旧数据）
  dataTarget: '',       // 数据目标（兼容旧数据）
  dataSourceTable: '',  // 数据源-绑定表
  dataSourceField: '',  // 数据源-绑定字段
  dataTargetTable: '',  // 数据目标-绑定表
  dataTargetField: '',  // 数据目标-绑定字段
  defaultValue: '',     // 默认值

  // 校验
  required: false,   // 必填
  maxLength: null,   // 最大长度
  minLength: null,   // 最小长度
  regex: '',         // 正则校验
  regexMsg: '',      // 校验提示

  // 显示
  label: '',         // 标签
  placeholder: '',   // 占位
  hint: '',          // 提示信息
  readonly: false,   // 只读
  disabled: false,   // 禁用
  hidden: false,     // 隐藏
  printHide: false,  // 打印隐藏

  // 权限
  visibleRoles: '',     // 可见角色（逗号分隔GUID）
  visibleUsers: '',     // 可见用户（逗号分隔GUID）
  visibleOrgs: '',      // 可见组织（逗号分隔GUID）
  editableRoles: '',    // 可编辑角色（逗号分隔GUID）
  editableUsers: '',    // 可编辑用户（逗号分隔GUID）
  editableOrgs: '',     // 可编辑组织（逗号分隔GUID）

  // 事件
  onChange: '',      // 值变化事件
  onFocus: '',       // 获得焦点事件
  onBlur: '',        // 失去焦点事件
  onClick: '',       // 点击事件

  // 其他
  sortOrder: 0,      // 排序号
  colSpan: 12,        // 列宽

  // 标签样式
  labelColor: '',     // 标签颜色（空=默认）
  labelBold: false    // 标签加粗
}

export const controlRegistry = {
  // ===== 基础控件 =====
  Input:        { category: 'base', name: '文本框', icon: 'fa-i-cursor', colSpan: 6, defaultProps: { ...commonProps, label: '文本框', colSpan: 6, placeholder: '请输入', align: 'left', total: '', iscapital: false, ispercent: false, autobrowse: false, browsebindtable: '', browsefilter: '', browseshowfields: '', browseorderby: '', datamap: '' } },
  Textarea:     { category: 'base', name: '多行文本', icon: 'fa-align-left', colSpan: 12, defaultProps: { ...commonProps, label: '多行文本', colSpan: 12, rows: 4 } },
  InputNumber:  { category: 'base', name: '数字', icon: 'fa-calculator', colSpan: 4, defaultProps: { ...commonProps, label: '数字', colSpan: 4, align: 'left', min: null, max: null, decimal: 0, separator: false, total: '', neg: false, notZero: false } },
  DatePicker:   { category: 'base', name: '日期', icon: 'fa-calendar', colSpan: 4, defaultProps: { ...commonProps, label: '日期', colSpan: 4, align: 'left', format: 'yyyy-MM-dd', type: 'date' } },
  DateRange:    { category: 'base', name: '日期区间', icon: 'fa-calendar', colSpan: 8, defaultProps: { ...commonProps, label: '日期区间', colSpan: 8, align: 'left', startPlaceholder: '开始日期', endPlaceholder: '结束日期', format: 'yyyy-MM-dd', type: 'date', showTimeInterval: false } },
  TimePicker:   { category: 'base', name: '时间', icon: 'fa-clock', colSpan: 3, defaultProps: { ...commonProps, label: '时间', colSpan: 3, align: 'left', format: 'HH:mm:ss' } },
  Select:       { category: 'base', name: '下拉框', icon: 'fa-caret-square-down', colSpan: 6, defaultProps: { ...commonProps, maxLength: undefined, minLength: undefined, label: '下拉框', colSpan: 6, options: '选项1,选项2,选项3', sourceType: 'Options', prompt: '', multiple: false, selectbindtable: '', selectvaluecolumn: '', selectdisplaycolumn: '', selectfilter: '', browseorderby: '', datamap: '' } },
  Radio:        { category: 'base', name: '单选', icon: 'fa-dot-circle', colSpan: 6, defaultProps: { ...commonProps, label: '单选', colSpan: 6, options: '选项1,选项2', direction: 'horizontal' } },
  Checkbox:     { category: 'base', name: '复选', icon: 'fa-check-square', colSpan: 6, defaultProps: { ...commonProps, label: '复选', colSpan: 6, options: '选项1,选项2', direction: 'horizontal', detailck: 'Default' } },
  TreeSelect:   { category: 'base', name: '树形选择', icon: 'fa-tree', colSpan: 6, defaultProps: { ...commonProps, defaultValue: undefined, maxLength: undefined, minLength: undefined, regex: undefined, regexMsg: undefined, label: '树形选择', colSpan: 6, placeholder: '请选择', multiple: false, selectbindtable: '', selectvaluecolumn: '', selectdisplaycolumn: '', treeIdField: '', treeParentIdField: '', treeRootValue: '', selectfilter: '', browseorderby: '', datamap: '', datamapList: [] } },
  Label:        { category: 'base', name: '文本', icon: 'fa-font', colSpan: 12, defaultProps: { ...commonProps, label: '', colSpan: 12, content: '显示文本', fontSize: 14, align: 'left', color: '#333', backgroundColor: '', borderRadius: '4', padding: '8', bold: false, labelStyle: 'header', lineHeight: null, boxShadow: '', letterSpacing: null } },
  HyperLink:    { category: 'base', name: '超链接', icon: 'fa-link', colSpan: 4, defaultProps: { ...commonProps, label: '', colSpan: 4, content: '链接文本', href: '#', target: '_blank', linktype: 'Default', taskid: '' } },
  Button:       { category: 'base', name: '按钮', icon: 'fa-hand-pointer', colSpan: 3, defaultProps: { text: '按钮', type: 'primary', size: 'medium', buttontype: '', buttonColor: '', textColor: '', mode: 'Single', browsedatasource: '', browsebindtable: '', browseshowfields: '', browsefilter: '', browseorderby: '', browseurl: '', datamap: '', morerow: false, notarget: false, copyrow: false, fieldId: '', fieldName: '', className: '', onClick: '', onChange: '', onFocus: '', onBlur: '' } },

  // ===== 高级控件 =====
  FileUpload:   { category: 'advance', name: '附件上传', icon: 'fa-paperclip', colSpan: 6, defaultProps: { ...commonProps, label: '附件', colSpan: 6, multiple: false, accept: '', displayType: 'link', fileMaxSize: 10, fileMaxCount: 1, attachmenttype: 'Upload', savetotable: false, isupload: false, isdelete: true, nodownload: false } },
  ImageUpload:  { category: 'advance', name: '图片上传', icon: 'fa-image', colSpan: 6, defaultProps: { ...commonProps, label: '图片', colSpan: 6, width: 150, height: 100, multiple: false, isupload: false, isdelete: true } },
  RichText:     { category: 'advance', name: '富文本', icon: 'fa-edit', colSpan: 12, defaultProps: { ...commonProps, label: '富文本', colSpan: 12, height: 200, rows: 6 } },
  SerialNumber: { category: 'advance', name: '流水号', icon: 'fa-list-ol', colSpan: 6, defaultProps: { ...commonProps, label: '流水号', colSpan: 6 } },
  UserPicker:   { category: 'advance', name: '人员选择', icon: 'fa-user', colSpan: 4, defaultProps: { ...commonProps, label: '人员', colSpan: 4, multiple: false } },
  DeptPicker:   { category: 'advance', name: '部门选择', icon: 'fa-building', colSpan: 4, defaultProps: { ...commonProps, label: '部门', colSpan: 4, multiple: false } },
  Position:     { category: 'advance', name: '岗位选择', icon: 'fa-briefcase', colSpan: 4, defaultProps: { ...commonProps, label: '岗位', colSpan: 4, multiple: false } },
  Signature:    { category: 'advance', name: '签名', icon: 'fa-signature', colSpan: 6, defaultProps: { ...commonProps, label: '签名', colSpan: 6, width: 240, height: 120 } },
  ScanCode:     { category: 'advance', name: '扫码', icon: 'fa-qrcode', colSpan: 3, defaultProps: { ...commonProps, label: '扫码', colSpan: 3 } },
  Formula:      { category: 'advance', name: '计算公式', icon: 'fa-function', colSpan: 4, defaultProps: { ...commonProps, label: '公式', colSpan: 4, formula: '', readonly: true } },
  Seal:         { category: 'advance', name: '电子签章', icon: 'fa-stamp', colSpan: 4, defaultProps: { ...commonProps, label: '签章', colSpan: 4 } },

  // ===== 布局控件 =====
  Tabs:         { category: 'layout', name: '标签页', icon: 'fa-folder', colSpan: 12, defaultProps: { ...commonProps, label: '', colSpan: 12, tabs: [{ title: 'Tab1', children: [] }, { title: 'Tab2', children: [] }] } },
  SubTable:     { category: 'layout', name: '子表', icon: 'fa-table', colSpan: 12, defaultProps: { ...commonProps, label: '', colSpan: 12, columns: [], headRows: 1, initRows: 1, addRows: 1, footerRows: 0, required: false, align: 'left', formgrid: true, needrow: false, formbindtable: '' } },
  TableLayout:  { category: 'layout', name: '表格布局', icon: 'fa-th', colSpan: 12, defaultProps: { ...commonProps, label: '', colSpan: 12, rows: 2, cols: 2, children: [] } },
  Divider:      { category: 'layout', name: '分割线', icon: 'fa-minus', colSpan: 12, defaultProps: { ...commonProps, label: '', colSpan: 12 } }
}

export function useFormState() {
  const forms = ref([{ id: 'form_1', name: '表单1', controls: [] }])
  const activeFormId = ref('form_1')
  const selectedControlId = ref(null)

  const activeForm = computed(() => forms.value.find(f => f.id === activeFormId.value))

  const selectedControl = computed(() => {
    if (!activeForm.value || !selectedControlId.value) return null
    return findControl(activeForm.value.controls, selectedControlId.value)
  })

  function findControl(controls, id) {
    for (const c of controls) {
      if (c.id === id) return c
      if (c.children) { const f = findControl(c.children, id); if (f) return f }
      if (c.type === 'Tabs' && c.props.tabs) {
        for (const t of c.props.tabs) { const f = findControl(t.children || [], id); if (f) return f }
      }
      if (c.type === 'SubTable' && c.props.columns) { const f = findControl(c.props.columns, id); if (f) return f }
      if (c.type === 'TableLayout' && c.props.children) { const f = findControl(c.props.children, id); if (f) return f }
    }
    return null
  }

  function addControl(type) {
    const reg = controlRegistry[type]
    if (!reg || !activeForm.value) return
    const ctrl = {
      id: genId(),
      type,
      props: { ...reg.defaultProps },
      children: null
    }
    if (['Tabs', 'SubTable', 'TableLayout'].includes(type)) {
      ctrl.children = []
    }
    activeForm.value.controls.push(ctrl)
    selectedControlId.value = ctrl.id
    return ctrl
  }

  function removeControl(id) {
    if (!activeForm.value) return
    _removeFromList(activeForm.value.controls, id)
    if (selectedControlId.value === id) selectedControlId.value = null
  }

  function _removeFromList(list, id) {
    const idx = list.findIndex(c => c.id === id)
    if (idx >= 0) { list.splice(idx, 1); return true }
    for (const c of list) {
      if (c.children && _removeFromList(c.children, id)) return true
      if (c.type === 'Tabs' && c.props.tabs) {
        for (const t of c.props.tabs) { if (_removeFromList(t.children || [], id)) return true }
      }
      if (c.type === 'SubTable' && c.props.columns) { if (_removeFromList(c.props.columns, id)) return true }
      if (c.type === 'TableLayout' && c.props.children) { if (_removeFromList(c.props.children, id)) return true }
    }
    return false
  }

  function moveControl(id, direction) {
    if (!activeForm.value) return
    const list = activeForm.value.controls
    const idx = list.findIndex(c => c.id === id)
    if (idx < 0) return
    const newIdx = idx + (direction === 'up' ? -1 : 1)
    if (newIdx < 0 || newIdx >= list.length) return
    const item = list.splice(idx, 1)[0]
    list.splice(newIdx, 0, item)
  }

  function duplicateControl(id) {
    const orig = findControl(activeForm.value.controls, id)
    if (!orig) return
    const copy = JSON.parse(JSON.stringify(orig))
    copy.id = genId()
    const parentList = _findParentList(activeForm.value.controls, id)
    if (parentList) {
      const idx = parentList.findIndex(c => c.id === id)
      parentList.splice(idx + 1, 0, copy)
    }
    selectedControlId.value = copy.id
  }

  function _findParentList(list, id) {
    for (let i = 0; i < list.length; i++) { if (list[i].id === id) return list }
    for (const c of list) {
      if (c.children) { const r = _findParentList(c.children, id); if (r) return r }
      if (c.type === 'Tabs' && c.props.tabs) {
        for (const t of c.props.tabs) { const r = _findParentList(t.children || [], id); if (r) return r }
      }
      if (c.type === 'TableLayout' && c.props.children) { const r = _findParentList(c.props.children, id); if (r) return r }
    }
    return null
  }

  function addForm(name) {
    const f = { id: 'form_' + (++nextId), name, controls: [] }
    forms.value.push(f)
    activeFormId.value = f.id
  }

  function removeForm(id) {
    if (forms.value.length <= 1) return
    const idx = forms.value.findIndex(f => f.id === id)
    forms.value.splice(idx, 1)
    activeFormId.value = forms.value[0].id
  }

  function updateControlProp(controlId, key, value) {
    const ctrl = findControl(activeForm.value.controls, controlId)
    if (ctrl) ctrl.props[key] = value
  }

  return {
    forms, activeFormId, selectedControlId, activeForm, selectedControl,
    addControl, removeControl, moveControl, duplicateControl,
    addForm, removeForm, updateControlProp, findControl
  }
}
